export default "__VITE_ASSET__BYJFN01b__"